import React from 'react'
import cardOne from './Images/rowFour/newsOne.jpg'
import cardTwo from './Images/rowFour/newsTwo.jpg'
import cardThree from './Images/rowOne/cardSeventy.jpg'
export default function RecentNews() {
    return (
        <div className='py-5' style={{backgroundColor:'#f8f9f9'}}>
        
            <h1 style={{ color: "#A10302",fontWeight:'bold'}} className="text-center mb-5">Recent News</h1>
            
                  <div >
          
            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-4">
                        <div style={{borderColor:"white",borderRadius:'0px'}} class="card">
                            <img src={cardOne} class="card-img-top" alt="..." />
                            <div style={{backgroundColor:'#f8f9f9'}} class="card-body">
                                <p class="card-title">Build a Wood Fired Clay Oven</p>
                                <p class="card-text">Last night, Construction was honored to accept a Best Builders Award from the Associated General Contractors...</p>
                                <a style={{color:'#A10302'}} href="#" >READ MORE</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div style={{borderColor:"white",borderRadius:'0px'}} class="card">
                            <img src={cardTwo} class="card-img-top" alt="..." />
                            <div style={{backgroundColor:'#f8f9f9'}} class="card-body">
                                <p class="card-title">Construction Honored with AGC Builders</p>
                                <p class="card-text">Last night, Construction was honored to accept a Best Builders Award from the Associated General Contractors...</p>
                                <a style={{color:'#A10302'}} href="#" >READ MORE</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div style={{borderColor:"white",borderRadius:'0px'}} class="card">
                            <img src={cardThree} class="card-img-top" alt="..." />
                            <div style={{backgroundColor:'#f8f9f9'}} class="card-body">
                                <p class="card-title">Finding New Buildings in the Dust
</p>
                                <p class="card-text">With the continued and growing emphasis on sustainability in construction we could be on the verge of a radical shift...</p>
                                <a style={{color:'#A10302'}} href="#" >READ MORE</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/services copy 4.jsx